// Single AuthClient instance per app — passed via React context (or imported
// directly) by the @mf/auth-client useAuth() hook. Base URL follows the
// /api/{serviceId}/* convention so api-ingress can routes by first path
// segment; mf-auth-adapter mounts the BFF at /auth/*. Mirrors id-start's
// lib/auth.ts so the three SPAs stay consistent.
import { AuthClient } from "@mf/auth-client";

export const authClient = new AuthClient({ baseUrl: "/api/mf-auth-adapter/auth" });
